import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledVideoEmbed = styled.iframe`
  border: none;
  margin-bottom: 48px;
`

const VideoEmbed = ({ cmsData }) => {
  const { height, width, embedLink } = cmsData
  const lang = 'en-US'
  const src = embedLink[lang] ? embedLink[lang] : embedLink
  const frameHeight = height && height[lang] ? height[lang] : height
  const frameWidth = width && width[lang] ? width[lang] : width

  return (
    <StyledVideoEmbed
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      frameborder="0"
      height={frameHeight || 'auto'}
      scrolling="no"
      src={src}
      width={frameWidth || '100%'}
    />
  )
}

VideoEmbed.propTypes = {
  cmsData: PropTypes.object.isRequired,
}

export default VideoEmbed
